import { useState } from 'react';
import { type GameCategory, type GameConfig } from '../../data/games';
import HomeGameCard from './HomeGameCard';

export default function HomeCategoryDetail({ category, completedLevels, onBack, onGameClick }: {
  category: GameCategory;
  completedLevels: string[];
  onBack: () => void;
  onGameClick: (game: GameConfig) => void;
}) {
  const [difficultyFilter, setDifficultyFilter] = useState<number | null>(null);
  const filteredGames = difficultyFilter
    ? category.games.filter(g => g.difficulty === difficultyFilter)
    : category.games;

  return <section className="cyber-panel cyber-wide">
    <div className="cyber-panel-head cyber-category-heading">
      <button onClick={onBack} className="cyber-icon" aria-label="返回训练分类">←</button>
      <div>
        <h2 className="cyber-panel-title">{category.icon} {category.name}</h2>
        <p className="cyber-description">{category.description}</p>
      </div>
      <span className="cyber-panel-meta">{category.games.length}款</span>
    </div>
    <div className="cyber-filters" aria-label="难度筛选">
      {[null, 1, 2, 3].map(d => <button
        key={d ?? 'all'}
        onClick={() => setDifficultyFilter(d)}
        aria-pressed={difficultyFilter === d}
        className={`cyber-tab ${difficultyFilter === d ? 'active' : ''}`}
      >{d === null ? '全部' : d === 1 ? '⭐ 入门' : d === 2 ? '⭐⭐ 进阶' : '⭐⭐⭐ 挑战'}</button>)}
    </div>
    <div className="cyber-games cyber-catalog-games">
      {filteredGames.map(game => <HomeGameCard key={game.id} game={game} onClick={() => onGameClick(game)} completed={completedLevels.includes(game.id)} />)}
    </div>
  </section>;
}
